import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logoImg from '../assets/logo.png';
import { Button } from '../components/ui/button';

export default function AcceptTerms() {
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState('');
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleContinue = () => {
    if (!accepted) {
      setError('Debes aceptar los Términos y Condiciones y la Política de Privacidad para continuar');
      return;
    }
    navigate('/onboarding', { replace: true });
  };

  return (
    <div className="min-h-screen bg-[hsl(35,25%,91%)] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex flex-col items-center gap-1">
          <img src={logoImg} alt="Partykatu" className="h-12 w-auto" />
          <span className="font-heading font-semibold text-xl text-[hsl(144,18%,38%)] tracking-tight" translate="no">Partykatu</span>
        </Link>
        <h2 className="mt-6 text-center font-heading font-bold text-2xl text-gray-900">
          Bienvenido/a{user?.name ? `, ${user.name}` : ''}
        </h2>
        <p className="mt-2 text-center text-gray-600 text-sm">
          Antes de continuar, necesitamos que aceptes nuestros términos
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-6 shadow-sm rounded-2xl border border-[hsl(35,20%,88%)]">

          {error && (
            <div className="mb-4 bg-red-50 text-red-600 px-4 py-3 rounded-xl text-sm">
              {error}
            </div>
          )}

          <div className="flex items-start gap-3 mb-6">
            <input
              type="checkbox"
              id="acceptTerms"
              checked={accepted}
              onChange={(e) => { setAccepted(e.target.checked); setError(''); }}
              className="mt-0.5 w-4 h-4 rounded border-gray-300 text-[hsl(144,18%,45%)] focus:ring-[hsl(144,18%,45%)] cursor-pointer flex-shrink-0"
            />
            <label htmlFor="acceptTerms" className="text-sm text-gray-600 leading-relaxed cursor-pointer">
              He leído y acepto los{' '}
              <Link to="/terminos" target="_blank" className="text-[hsl(144,18%,45%)] hover:underline font-medium">
                Términos y Condiciones
              </Link>{' '}
              y la{' '}
              <Link to="/privacidad" target="_blank" className="text-[hsl(144,18%,45%)] hover:underline font-medium">
                Política de Privacidad
              </Link>
              . Soy mayor de 18 años.
            </label>
          </div>

          <Button
            onClick={handleContinue}
            className="w-full bg-[hsl(144,18%,45%)] hover:bg-[hsl(144,18%,38%)] text-white rounded-xl py-3 font-medium disabled:opacity-50"
            disabled={!accepted}
          >
            Continuar
          </Button>
        </div>

        <p className="mt-6 text-center text-xs text-[hsl(20,8%,50%)]">
          © 2026 Partykatu ·{' '}
          <Link to="/aviso-legal" className="hover:underline">Aviso Legal</Link>
        </p>
      </div>
    </div>
  );
}
